export default "__VITE_ASSET__By5qrHjL__"